export default {
    'general': {
        'versioning': 'Ustvarjanje verzij',
        'dashboard': 'Nadzorna plošča',
        'email': 'E-pošta',
        'username': 'Uporabniško ime',
        'name': 'Ime',
        'password': 'Geslo',
        'actions': 'Dejanja',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Ni rezultatov',
        'success': 'Uspeh',
        'warning': 'Opozorilo',
        'remember_me': 'Zapomni si me',
        'error': 'Napaka',
        'edit': 'Uredi',
        'details': 'Podrobnosti',
        'add': 'Dodaj',
        'delete': 'Izbriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Prekliči',
        'back': 'Nazaj',
        'image': 'Slika',
        'filters': 'Filtri',
        'remove_filters': 'Odstrani filtre',
        'default': 'Privzeto',
        'save': 'Shrani',
        'key': 'Ključ',
        'distribution_zone': 'Distribucijsko območje',
        'preview': 'Predogled',
        'icon': 'Ikona',
        'last_edited': 'Nazadnje urejeno',
        'unknown': 'Neznano',
        'latest_version': 'Najnovejša verzija',
        'change': 'Spremeni',
        'unlimited': 'Neomejeno',
        'from': 'Od',
        'to': 'Do',
        'date': 'Datum',
        'profile': 'Profil',
        'custom': 'Po meri'
    },
    'errors': {
        'generic_error': 'Prišlo je do napake',
        'login': 'Prišlo je do napake pri prijavi',
        'logout': 'Prišlo je do napake pri odjavi',
        'incorrect_password': 'Staro geslo ni pravilno',
        'no_access': 'Ni dostopa',
        'invalid_data': 'Prejeti neveljavni podatki',
        'not_found': 'Podatki niso najdeni',
        'user_exist': 'Uporabnik s tem uporabniškim imenom že obstaja',
        'load_data': 'Prišlo je do napake pri nalaganju podatkov',
        'on_upload_image': 'Prišlo je do napake pri nalaganju slik',
        'on_upload_file': 'Prišlo je do napake pri nalaganju datotek',
        'on_publish': 'Prišlo je do napake med objavljanjem',
        'on_approve': 'Prišlo je do napake med potrjevanjem',
        'on_download': 'Prišlo je do napake med prenosom datoteke',
        'on_add': 'Prišlo je do napake pri dodajanju',
        'on_edit': 'Prišlo je do napake pri urejanju',
        'on_delete': 'Prišlo je do napake pri brisanju',
        'on_sort': 'Prišlo je do napake pri razvrščanju',
        'unauthorized': 'Nepooblaščeno',
        'user_does_not_exist': 'Uporabnik ne obstaja',
        'username_exists': 'To uporabniško ime že obstaja. Prosimo, uporabite drugo.',
        'failed_to_insert': 'Vstavljanje ni uspelo',
        'file_to_big': 'Datoteka je prevelika',
        'missing_roles': 'Manjkajoče vloge',
        'no_roles_selected': 'Uporabnik mora imeti izbrano vsaj eno vlogo',
        'fetching_data': 'Napaka pri pridobivanju podatkov',
        'deleting_default_data': 'Napaka pri brisanju privzetih podatkov',
        'data_already_exists': 'Podatki že obstajajo',
        'unable_to_retrieve_extension': 'Razširitve ni mogoče pridobiti',
        'role_exists': 'Vloga obstaja',
        'role_does_not_exist': 'Vloga ne obstaja',
        'time_parser': {
            'invalid_character_error': 'Dovoljene so samo številke in {0} enote.',
            'number': 'številka',
            'unit': 'enota',
            'invalid_format_error': 'Enote morajo biti v obliki',
            'duplicated_unit_error': 'Enota {0} je podvojena.',
            'example': '(primer: 3d12h)'
        },
        'max_queue_time': 'Prekoračen je največji čas za čakalno vrsto. Prosimo, uporabite krajše trajanje.',
        'queue_time_to_small': 'Čas čakalne vrste je prekratek. Uporabite daljše trajanje.'
    },
    'success': {
        'on_add': 'Uspešno dodano',
        'on_edit': 'Uspešno urejeno',
        'on_delete': 'Uspešno izbrisano',
        'on_publish': 'Uspešno objavljeno',
        'on_approve': 'Uspešno potrjeno',
        'on_sort': 'Uspešno razvrščeno',
        'on_change_password': 'Geslo je bilo uspešno spremenjeno',
        'channel_package_activated': 'Paket kanalov je bil uspešno aktiviran',
        'channel_package_deactivated': 'Paket kanalov je bil uspešno deaktiviran'
    },
    'confirmations': {
        'general': 'Ali ste prepričani, da želite nadaljevati?',
        'header': 'Ali ste prepričani',
        'delete_row': 'Ali ste prepričani, da želite izbrisati',
        'deactivate_row': 'Ali ste prepričani, da želite deaktivirati',
        'publish': 'Ali ste prepričani, da želite objaviti na',
        'approve': 'Ali ste prepričani, da želite potrditi'
    },
    'table': {
        'no_data': 'Ni podatkov za prikaz',
        'press_enter_search': 'Pritisnite enter za iskanje',
        'search': 'Iskanje po',
        'select_option': 'Izberi možnost',
        'select_date': 'Izberi datum',
        'select_range': 'Izberi obseg',
        'of': 'od'
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Staro geslo',
        'new_password': 'Novo geslo',
        'confirm_password': 'Potrdi geslo',
        'change_password_text': 'Če je polje za geslo prazno, se geslo ne bo spremenilo.',
        'change_password': 'Spremeni geslo'
    },
    'user': {
        'user': 'Uporabnik | Uporabniki',
        'add': 'Dodaj uporabnika',
        'edit': 'Uredi uporabnika',
        'name': 'Ime',
        'username': 'Uporabniško ime',
        'password': 'Geslo',
        'confirm_password': 'Potrdi geslo',
        'cannot_edit_username': 'Uporabniškega imena ni mogoče urejati',
        'change_password': 'Spremeni geslo',
        'new_password': 'Novo geslo'
    },
    'task': {
        'task': 'Opravilo | Opravila',
        'add': 'Dodaj opravilo',
        'edit': 'Uredi opravilo',
        'time': 'Čas',
        'message': 'Sporočilo',
        'valid_units': 'Veljavne enote: {value} (dan, ura, minuta).',
        'decimals_not_allowed': 'Decimalke niso dovoljene',
        'reformat_time': 'Preoblikuj čas',
        'invalid_character_error': 'Dovoljene so samo številke in enote \'d\', \'h\', \'m\'.',
        'number': 'številka',
        'unit': 'enota',
        'invalid_format_error': 'Enota mora biti v obliki',
        'duplicated_unit_error': 'Enota {0} je podvojena.'
    },
    'task_type': {
        'task_type': 'Tip opravila | Tipi opravil',
        'add': 'Dodaj tip opravila',
        'edit': 'Uredi tip opravila',
        'color': 'Barva',
        'monthly_billing_breakpoint': 'Mesečna prelomnica obračunavanja'
    },
    'customer': {
        'customer': 'Stranka | Stranke',
        'customer_name': 'Ime stranke'
    }
}
